// Angular
import { Component, OnInit } from '@angular/core';

// Services
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { WHAT } from 'src/app/shared/classes';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CountriesComponent } from 'src/app/shared/modals/countries/countries.component';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.less']
})
export class SummaryComponent implements OnInit {
  public allSummaries = {
    adminuser: '',
    applications: '',
    devices: '',
    projects: '',
    groups: '',
    users: '',
    transactions: '',
    vouchers: '',
    countrys: '',
    device_online:'',
    licenses:'',
    managers:''
  };

  constructor(private admin: AdminService, private msg: MessagesService, private load: NgxSpinnerService, private ngbModal: NgbModal) { }

  ngOnInit() {
    this.load.show();

    this.getSummaryData();
  }

  // get summary of data
  private getSummaryData() {
    this.admin.GET(WHAT.Summary)
      .then(res => this.processResponse(res))
      .catch(error => this.handleError(error));
  }

  // set data to template object (public)
  private processResponse(res) {
    // set the object from res
    for (const i in this.allSummaries) {
      const keys = Object.keys(res);
      for (let kr = 0; kr < keys.length; kr++) {
        if (i === keys[kr]) {
          this.allSummaries[i] = res[keys[kr]] || '0';
        }
      }
    }
    this.load.hide();
  }

  // opens country table modal
  public async openCountryTableModal() {
    const modal = this.ngbModal.open(CountriesComponent, {
      size: 'lg'
    });
  }

  // handle error
  private handleError(error) {
    this.load.hide();

    this.msg.error(error);
  }

}
